import Api from '@/services/Api'

export const HubspotApiService = {
  /**
   * Fetch a HubSpot Visitor Identification token for the authenticated user.
   * The token is an HMAC-SHA256 hash generated server-side and is required
   * to identify the user to the HubSpot chat widget.
   *
   * @returns {Promise<string>} The visitor identification token
   */
  async fetchVisitorToken () {
    const response = await Api.get('user/hubspot-visitor-token')
    return response.data.data.token
  }
}
